module.exports = __webpack_public_path__ + "static/media/angry_cloud.ad66e919.svg";